export enum AuthActionType {
    LOGIN = 'login',
    ME = 'me'
}